
import gql from 'graphql-tag'
export default gql`
    query ViLabelsByType ($from: Date, $to: Date, $noCache: Boolean) {
      ViLabelsByType (from: $from, to: $to, noCache: $noCache) {
        type
        masterCount
        labelCount
        durationSum
      }
    }
  `
